import { ProethicaPrinciplesExplorer } from "@features/proethica-principles";
import type { ProethicaPrinciple } from "@features/proethica-principles";

interface Props {
	principles: ProethicaPrinciple[];
}

const PrinciplesAccordion = ({ principles }: Props) => (
	<ProethicaPrinciplesExplorer principles={principles} />
);

export default PrinciplesAccordion;
